// extracted by mini-css-extract-plugin
export default {"bulkEntryInfoMessage":"BaseMessage-styles__bulkEntryInfoMessage___yhk7C"};